import {
    GET_MODEBIS_CONFIG_ERROR,
    GET_MODEBIS_CONFIG_START,
    GET_MODEBIS_CONFIG_SUCCESS,
} from "../actions/config";
import {
    GET_METERING_PACKAGE_ERROR,
    GET_METERING_PACKAGE_START,
    GET_METERING_PACKAGE_SUCCESS,
} from "../actions/userPackage";

interface ModeBisConfigPayload {
    createdAt?: string;
    createdBy?: string;
    itemId?: string;
    readOnly?: boolean;
    updatedAt?: string;
    updatedBy?: string;
    version?: string;
    trialExpire?: number;
}

interface MeteringPackagePayload {
    expireDate?: string;
}

export type ModebisConfigAction =
    | { type: typeof GET_MODEBIS_CONFIG_START }
    | { type: typeof GET_MODEBIS_CONFIG_SUCCESS; payload: ModeBisConfigPayload }
    | { type: typeof GET_MODEBIS_CONFIG_ERROR }
    | { type: typeof GET_METERING_PACKAGE_START }
    | {
          type: typeof GET_METERING_PACKAGE_SUCCESS;
          payload: MeteringPackagePayload;
      }
    | { type: typeof GET_METERING_PACKAGE_ERROR };

interface ModebisConfigState {
    createdAt?: string;
    createdBy?: string;
    itemId?: string;
    readOnly?: boolean;
    updatedAt?: string;
    updatedBy?: string;
    version?: string;
    trial?: boolean;
    trialExpire?: number;
    isLoadingConfig?: boolean;
}

const initialState: ModebisConfigState = {
    trial: false,
    trialExpire: -1,
    isLoadingConfig: false,
};

const dateDifferenceInDays = (dateStr: string): number => {
    let daysDifferences: number = -1;
    let date1 = new Date();
    let date2 = new Date(dateStr);

    let Difference_In_Time = date2.getTime() - date1.getTime();

    // To calculate the no. of days between two dates
    daysDifferences = Math.round(Difference_In_Time / (1000 * 3600 * 24));
    return daysDifferences;
};

const modebisconfig = (state = initialState, action: ModebisConfigAction) => {
    switch (action.type) {
        case GET_MODEBIS_CONFIG_START:
            return { ...initialState, isLoadingConfig: true };
        case GET_MODEBIS_CONFIG_ERROR:
            return initialState;
        case GET_MODEBIS_CONFIG_SUCCESS:
            return {
                ...state,
                ...action.payload,
                trial: action.payload?.version === "LIGHT",
                isLoadingConfig: false,
            };
        case GET_METERING_PACKAGE_START:
        case GET_METERING_PACKAGE_ERROR:
            return {
                ...state,
                trialExpire: -1,
            };
        case GET_METERING_PACKAGE_SUCCESS:
            return {
                ...state,
                trialExpire: action.payload?.expireDate
                    ? dateDifferenceInDays(action.payload.expireDate)
                    : -1,
            };
        default:
            return state;
    }
};
export default modebisconfig;
